import React from 'react';
import { Divider, Stack, SxProps } from '@mui/material';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

import ContentDescription from '@/components/MenuDrawer/MyMenuDrawer/@components/ContentDescription';
import useMailSignatureProps from './@hooks/useMailSignatureProps';
import { SubContentProps } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/LanguageSetting';
import VerticalStyle from './VerticalStyle';
import Link from '@/components/@IntranetLibrary/Link';
import { EMailSignatureData } from '@/hooks/apiHooks';
import HorizontalStyle from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/MailSignature/HorizontalStyle';
import { useMypageEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { MypageEventName } from '@/constant/gtm';
import { useTranslation } from 'react-i18next';

const MarginTop = `${32 - 24}px`;

export const SignatureTypeTitle: { [key in string]: string } = {
  horizontal_style_namecard: 'Type 1. 가로형 서명',
  vertical_style_namecard: 'Type 2. 세로형 서명',
};

export type SignatureCardProps = {
  readonly data: EMailSignatureData;
  readonly copyMailSignature: (idName: string) => void;
  readonly wrapperStyle?: SxProps;
};

const MailSignature = (props: SubContentProps) => {
  const { t } = useTranslation();
  const { data, copyMailSignature, mailLink } = useMailSignatureProps(props);
  const mypageEventTracker = useMypageEventTracker();

  const onClickCopy = (id: string) => {
    copyMailSignature(id);
    // GA Mypage - 13번
    mypageEventTracker(MypageEventName.clickEvent, {
      area_name: '메일 서명',
      contents: '복사',
      status: undefined,
      description: `서명 복사하기_${SignatureTypeTitle[id] || id}`,
    });
  };

  return (
    <>
      <ContentDescription
        hasVerticalMargin={true}
        sx={{ marginBottom: '16px' }}
      >
        {t(
          'MYPAGE.원하시는 서명을 아래에서 복사 후 Outlook에서 설정해 사용하세요.',
        )}
      </ContentDescription>
      <Link
        size="large"
        variant={'secondary'}
        href={mailLink}
        target="_blank"
        onClick={() => {
          // GA Mypage - 12번
          mypageEventTracker(MypageEventName.clickOutLink, {
            area_name: '메일 서명',
            button_text: 'Outlook에서 설정하기',
          });
        }}
        sx={{
          '& img': {
            width: '20px',
            height: '20px',
            marginRight: '4px',
          },
        }}
      >
        <img src={'/icons/logo/outlook.png'} alt={'outlook icon'} />
        {t('MYPAGE.Outlook에서 설정하기')}
      </Link>
      <Stack gap={'24px'} mt={'28px'}>
        <Divider />
        {data ? (
          <>
            <HorizontalStyle data={data} copyMailSignature={onClickCopy} />
            <VerticalStyle data={data} copyMailSignature={onClickCopy} />
          </>
        ) : (
          <>
            <Skeleton variant={'text'} width={'100%'} height={180} />
            <Skeleton
              variant={'text'}
              width={'100%'}
              height={180}
              sx={{ marginTop: MarginTop }}
            />
          </>
        )}
      </Stack>
    </>
  );
};

export default MailSignature;
